import React from 'react'
import styles from './PopoverMenu.scss'
import { Popover } from 'common/styleguide/Popover'
import cx from 'classnames'

// li elements only, please
export const PopoverMenu = ({ children, className, ...props }) => (
  <Popover noPadding {...props}>
    <ul className={cx(styles.PopoverMenu, className)}>
      {children}
    </ul>
  </Popover>
)

export const PopoverMenuItem = ({ className, ...props }) => (
  <li className={cx(styles.PopoverMenuItem, className)} {...props} />
)

export const PopoverMenuHeading = ({ children, ...props }) => (
  <li className={styles.listHeading} {...props}>
    {children}
  </li>
)
